export function formatCurrency(amount: number) {
	return new Intl.NumberFormat("nl-NL", {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
	}).format(amount);
}
